import { createRoot } from 'react-dom/client'
import './index.css'
import { preloadStorage } from '@/lib/storageBackend'

/**
 * Boot do app. PRIMEIRO pré-carrega o estado persistido (IndexedDB → cache
 * síncrono) e SÓ ENTÃO importa dinamicamente a árvore React (Root → App →
 * contexts → store). Isso garante que o store inicialize de forma síncrona já
 * com os dados certos, sem reescrever o boot para ser assíncrono.
 *
 * À prova de falhas: `preloadStorage()` nunca rejeita (cai para localStorage se
 * o IndexedDB falhar), então o app sempre sobe.
 */
async function bootstrap() {
  await preloadStorage()
  const { Root } = await import('./Root')
  createRoot(document.getElementById('root')!).render(<Root />)
}

void bootstrap()
